<script setup>
import { computed } from 'vue';
import Button from './Button.vue';

const props = defineProps(['showProp', 'textProp']);

const emit = defineEmits(['close', 'confirmed']);

const show = computed(() => props.showProp);

const close = () => {
  emit('close');
};

const confirm = () => {
  emit('confirmed');
};


defineExpose({ show, close });
</script>

<template>
  <!-- <Transition name="bounce"> -->
    <div class="modal" v-if="show">
      <div class="modal-content">
        
        <div class="dialog-text">{{ textProp }}</div>

        <div class="buttons-container">
            <Button class="button" @click="confirm">Yes</Button>
            <Button class="button" @click="close">No</Button>
        </div>
      </div>
    </div>
  <!-- </Transition> -->
  </template>

  

  
  <style scoped>
  .modal {
    /* position: relative;
    z-index: 999;
    left: 0;
    top: -20; */
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(20px);
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.18);
  }
  
  .modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: space-around;
    justify-content: space-around;
  }
.dialog-text{
    font-size: 2rem;
    text-align: center;
}
  .buttons-container{
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-self: flex-end;
  }

  .button{
    min-width: 100px;
  }

  
  .fade-enter-active,
  .bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
  </style>
  